import Vue from 'vue'
import {
  Button,
  NavBar,
  Field,
  CellGroup,
  Toast,
  Tabbar,
  TabbarItem,
  Tab,
  Tabs,
  List,
  PullRefresh,
  Cell,
  Grid,
  GridItem,
  Image,
  Lazyload,
  Popup,
  Icon,
  ActionSheet,
  Search,
  Loading,
  Divider,
  Dialog,
  Tag,
  Row,
  Col,
  DatetimePicker,
  Image as VanImage,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Uploader,
  Form,
  Card,
  Panel
} from 'vant'

Vue.use(DatetimePicker)
Vue.use(Tag)
Vue.use(Row)
Vue.use(Col)
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(Toast)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Cell)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Image)
Vue.use(Lazyload)
Vue.use(Popup)
Vue.use(Icon)
Vue.use(ActionSheet)
Vue.use(Search)
Vue.use(Loading)
Vue.use(Divider)
Vue.use(Dialog)
Vue.use(VanImage)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Uploader)
Vue.use(Form)
Vue.use(Card)
Vue.use(Panel)
